export const paths = {
  categories: "/categories",
  category: "/categories/:type",
  game: "/games/:game",
};
